// extracted by mini-css-extract-plugin
export default {"TextFieldCustom":"styles_TextFieldCustom__8lnl3"};